import { IconDefinition } from '@ant-design/icons-angular';
export const UserAltIcon: IconDefinition = {
  name: 'user-alt',
  theme: 'outline',
  icon: `
    <svg xmlns="http://www.w3.org/2000/svg" width="13.206" height="16" viewBox="0 0 13.206 16">
  <path id="user-alt" d="M22.6,15.619a3.81,3.81,0,1,0-3.81-3.81A3.81,3.81,0,0,0,22.6,15.619ZM21.66,17.4A5.659,5.659,0,0,0,16,23.057a.943.943,0,0,0,.943.943H28.263a.943.943,0,0,0,.943-.943,5.659,5.659,0,0,0-5.66-5.66Z" transform="translate(-16 -8)" fill="currentColor"/>
</svg>


  `,
};
export const UserTieIcon: IconDefinition = {
  name: 'user-tie',
  theme: 'outline',
  icon: `
 <svg xmlns="http://www.w3.org/2000/svg" width="13.206" height="16" viewBox="0 0 13.206 16">
  <path id="user-tie" d="M22.6,15.619a3.81,3.81,0,1,1,3.81-3.81A3.81,3.81,0,0,1,22.6,15.619ZM21.635,17.4h1.937a.556.556,0,0,1,.422.917l-.87,1.016.984,3.654h.019l1.1-4.4a.472.472,0,0,1,.619-.343,5.227,5.227,0,0,1,3.362,4.883.871.871,0,0,1-.87.87L16.87,24a.871.871,0,0,1-.87-.87,5.227,5.227,0,0,1,3.362-4.883.472.472,0,0,1,.619.343l1.1,4.4H21.1l.984-3.654-.87-1.016a.556.556,0,0,1,.422-.917Z" transform="translate(-16 -8)" fill="currentColor"/>
</svg>

  `,
};
